import apiClient from '@/lib/axios';
import type { ApiResponse, LeadStatus } from '../types';

/**
 * Request payload for checking duplicate leads
 * Field names must match backend DuplicateCheckRequest DTO
 */
export interface DuplicateCheckRequest {
  excludeLeadId?: number;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  propertyAddress1?: string;
  propertyCity?: string;
  propertyZip?: string;
  homePhone?: string;
  cellPhone?: string;
  workPhone?: string;
  email?: string;
}

/**
 * Potential duplicate lead returned from the API
 */
export interface PotentialDuplicate {
  id: number;
  jobNumber?: string;
  customerName: string;
  address: string;
  status: LeadStatus;
  matchReasons: string[];
}

/**
 * Response from the duplicate check API
 */
export interface DuplicateCheckResponse {
  hasDuplicates: boolean;
  duplicates: PotentialDuplicate[];
}

/**
 * Check for potential duplicate leads based on customer information.
 * This should be called before saving a new or updated lead.
 *
 * @param data - Customer information to check for duplicates
 * @returns Promise containing duplicate check results
 */
export const checkDuplicates = async (
  data: DuplicateCheckRequest
): Promise<DuplicateCheckResponse> => {
  const response = await apiClient.post<ApiResponse<DuplicateCheckResponse>>(
    '/leads/check-duplicates',
    data
  );
  return response.data.data;
};
